document.addEventListener('DOMContentLoaded', () => {

    const lectures = [
        {
            id: 'naering-andleg-lidan',
            title: 'Næring og andleg líðan',
            description: 'Lærðu hvernig mataræði hefur bein áhrif á hugarfar, orku og andlega heilsu.',
            imageUrl: 'https://images.unsplash.com/photo-1543362906-acfc16c67564?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80',
            videoId: '4a2dPX3t_gM',
        },
        {
            id: 'svefn-lykill-ad-arangi',
            title: 'Svefn: Lykill að árangri',
            description: 'Af hverju er svefn svona mikilvægur? Kynntu þér vísindin á bakvið góðan nætursvefn.',
            imageUrl: 'https://images.unsplash.com/photo-1531353826977-0941b4779a1C?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80',
            videoId: '1U2iU0a_crE',
        },
        {
            id: 'hreyfing-og-hvatning',
            title: 'Hreyfing og hvatning: Komdu þér af stað',
            description: 'Hagnýt ráð til að finna hreyfingu við þitt hæfi og halda hvatningunni til lengri tíma.',
            imageUrl: 'https://images.unsplash.com/photo-1487958449943-2429e8be8625?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80',
            videoId: 'g-jwWYX7Jlo',
        },
    ];

    const grid = document.getElementById('lecture-grid-container');
    const modalOverlay = document.getElementById('lecture-modal-overlay');
    const modalContent = document.getElementById('modal-lecture-content');
    const modalCloseButton = modalOverlay.querySelector('.modal-close-button');

    function displayLectures() {
        if (!grid) return;
        grid.innerHTML = '';
        lectures.forEach(lecture => {
            const card = document.createElement('div');
            card.className = 'lecture-card';
            card.dataset.id = lecture.id;
            // Setjum myndina sem bakgrunn á spjaldið
            card.style.backgroundImage = `url('${lecture.imageUrl}')`;
            
            // Búum til innihaldið fyrir textann
            card.innerHTML = `
                <div class="lecture-info">
                    <h3>${lecture.title}</h3>
                </div>
            `;
            grid.appendChild(card);
        });
    }

    function openModal(lectureId) {
        const lecture = lectures.find(l => l.id === lectureId);
        if (!lecture) return;

        modalContent.innerHTML = `
            <div class="video-container">
                <iframe src="https://www.youtube.com/embed/${lecture.videoId}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div id="modal-lecture-info">
                <h2>${lecture.title}</h2>
                <p>${lecture.description}</p>
            </div>
        `;

        modalOverlay.style.display = 'flex';
        document.body.style.overflow = 'hidden';
    }

    function closeModal() {
        modalContent.innerHTML = ''; 
        modalOverlay.style.display = 'none';
        document.body.style.overflow = 'auto';
    }

    // Event Listeners
    grid.addEventListener('click', e => {
        const card = e.target.closest('.lecture-card');
        if (card) {
            openModal(card.dataset.id);
        }
    });

    modalCloseButton.addEventListener('click', closeModal);
    modalOverlay.addEventListener('click', e => { if (e.target === modalOverlay) closeModal(); });

    // Fyrsta birting
    displayLectures();
});